import { format, formatDistanceToNowStrict } from "date-fns";

interface TimestampProps {
  value?: string | null;
}

/** The exact-value tooltip text a `Timestamp` shows, for a caller that wants
 * the same tooltip on a wrapping element (e.g. an icon next to it), so
 * hovering that element shows it too. */
export function formatTimestampTitle(value: string): string {
  return format(new Date(value), "PPpp");
}

/** Relative age that keeps its exact value in a tooltip. */
export function Timestamp({ value }: TimestampProps) {
  if (!value) {
    return <>—</>;
  }
  const date = new Date(value);
  return (
    <time dateTime={date.toISOString()} title={formatTimestampTitle(value)}>
      {formatDistanceToNowStrict(date, { addSuffix: true })}
    </time>
  );
}
